import React, { useState, useEffect, useRef } from "react";
import { X, MoreHorizontal, Copy } from "lucide-react";
import { useHistory, useLocation } from "react-router-dom";
import Pagination from "./Pagination";
import noImage from '../assets/img/brand/noImage.png';

const DRAWER_PAGE_SIZE = 5;

export default function PlatformOrderDrawer({
  drawerOpen,
  selectedRow,
  setDrawerOpen,
  setSelectedRow,
  platformName = "Order Info",
  detailLoading = false,
}) {
  const history = useHistory();
  const { pathname } = useLocation();

  const [drawerTab, setDrawerTab] = useState("entity-info");
  const [copied, setCopied] = useState(false);
  const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
  const [orderItemsPage, setOrderItemsPage] = useState(1);
  const [stockItemsPage, setStockItemsPage] = useState(1);

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipContent, setTooltipContent] = useState("");
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const showTooltipHandler = (text, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipContent(text);
    setTooltipPosition({ top: rect.top, left: rect.left + rect.width / 2 });
    setShowTooltip(true);
  };

  const hideTooltipHandler = () => setShowTooltip(false);

  const toggleToolbarDropdown = () => {
    setToolbarDropdownOpen((prev) => !prev);
  };

  const drawerRef = useRef(null);
  const toolbarRef = useRef(null);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      drawerOpen &&
      drawerRef.current &&
      !drawerRef.current.contains(event.target)
    ) {
      setDrawerOpen(false);
      setSelectedRow(null);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [drawerOpen, setDrawerOpen, setSelectedRow]);

  useEffect(() => {
    if (drawerOpen) {
      setOrderItemsPage(1);
      setStockItemsPage(1);
    }
  }, [drawerOpen]);

  if (!drawerOpen || !selectedRow) return null;

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  /* ================= PAGINATION ================= */

  const orderItems = selectedRow?.products || [];
  const orderItemsTotal = orderItems.length;
  const orderItemsTotalPages = Math.ceil(orderItemsTotal / DRAWER_PAGE_SIZE);
 

  const paginatedOrderItems = orderItems.slice(
    (orderItemsPage - 1) * DRAWER_PAGE_SIZE,
    orderItemsPage * DRAWER_PAGE_SIZE
  );

  const stockItems = selectedRow?.stockInstances || [];
  console.log("stockItems===>", selectedRow);
  const stockItemsTotal = stockItems.length;
  const stockItemsTotalPages = Math.ceil(stockItemsTotal / DRAWER_PAGE_SIZE);

  const paginatedStockItems = stockItems.slice(
    (stockItemsPage - 1) * DRAWER_PAGE_SIZE,
    stockItemsPage * DRAWER_PAGE_SIZE
  );

  const Field = ({ label, value }) => (
    <div>
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: "#495057",
          marginBottom: 6,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 12, fontWeight: 400, color: "#212529" }}>
        {value || "-"}
      </div>
    </div>
  );

  const pendingCount = selectedRow.pending?.reduce((sum, item) => sum + item.count, 0) || 0;
                    const total = Number(selectedRow.available || 0) + pendingCount;
                    return (
                        <>
                            <div className="drawer-overlay main-drawer-overlay" />
                            <div className="entity-drawer" ref={drawerRef}>
                                <div className="drawer-header"
                                  style={{
                                    display: "flex",
                                    height: "60px",
                                    padding: "15px 20px",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    alignSelf: "stretch",
                                    background: "var(--Gray-100, #F8F9FA)",
                                  }}
                                >
                                    <h3 style={{
                                      color: "var(--Gray-900, #212529)",
                                      fontFamily: "Montserrat",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: 600,
                                      lineHeight: "normal",
                                    }}>{platformName} Order Info</h3>
                                    <button
                                        className="close-btn"
                                        onClick={() => {
                                            setDrawerOpen(false);
                                            setSelectedRow(null);
                                        }}
                                    >
                                        <X size={24} />
                                    </button>
                                </div>
                                <div className="main-drawer-inner" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div
                                      className="drawer-title"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {/* LEFT SIDE */}
                                      <h2 className="pb-0" style={{ margin: 0 }}>
                                        {selectedRow?.id}
                                      </h2>

                                      {/* RIGHT SIDE */}
                                      <div style={{ position: "relative" }} ref={toolbarRef}>
                                        <button
                                          className="drawer-dots"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            toggleToolbarDropdown();
                                          }}
                                          style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: '8px',
                                            borderRadius: 8,
                                            
                                            boxShadow: toolbarDropdownOpen ? '0 1px 4px 0 rgba(0, 0, 0, 0.10)' : 'none',
                                          }}
                                        >
                                          <MoreHorizontal size={18} padding={8} />
                                        </button>

                                        {toolbarDropdownOpen && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: 45,
                                              right: 0,
                                              background: "white",
                                              boxShadow: "0px 1px 4px 0px #0000001A",
                                              zIndex: 1000,
                                              minWidth: 200,
                                              borderRadius: 8,
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div>
                                              <button
                                                disabled={["cancelled","canceled"].includes(selectedRow?.status?.toLowerCase())}
                                                onClick={() => {
                                                  setToolbarDropdownOpen(false);
                                                  history.push("/platform-manage-order", {
                                                    order: selectedRow,
                                                    platformLabel: platformName,
                                                    fromPath: pathname,
                                                  });
                                                }}
                                                style={{
                                                  width: "100%",
                                                  padding: "10px",
                                                  textAlign: "left",
                                                  background: "transparent",
                                                  border: "none",
                                                  cursor: ["cancelled","canceled"].includes(selectedRow?.status?.toLowerCase()) ? "not-allowed" : "pointer",
                                                  fontSize:14,
                                                  fontWeight:400,
                                                  opacity: ["cancelled","canceled"].includes(selectedRow?.status?.toLowerCase()) ? 0.4 : 1,
                                                }}
                                              >
                                                Manage
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>


                                    <div className="drawer-tabs">
                                        <button
                                            className={drawerTab === 'entity-info' ? 'active' : ''}
                                            onClick={() => setDrawerTab('entity-info')}
                                        >
                                            General
                                        </button>
                                        <button
                                            className={drawerTab === 'order-items' ? 'active' : ''}
                                            onClick={() => setDrawerTab('order-items')}
                                        >
                                            Items and Linkage
                                        </button>
                                        <button
                                            className={drawerTab === 'additional-info' ? 'active' : ''}
                                            onClick={() => setDrawerTab('additional-info')}
                                        >
                                            Additional
                                        </button>
                                    </div>

                                    <div className="drawer-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        {drawerTab === "entity-info" && (
                                          <div
                                            style={{
                                              borderRadius: 12,
                                              overflow: "hidden",
                                              border: "1px solid #E9ECEF",
                                            }}
                                          >
                                            {/* Header */}
                                            <div
                                              style={{
                                                background: "#F8F9FA",
                                                padding: "14px 20px",
                                                fontFamily: "Montserrat",
                                                fontSize: 14,
                                                fontWeight: 600,
                                                color: "#212529",
                                              }}
                                            >
                                              Basic Info
                                            </div>

                                            {/* Content */}
                                            <div
                                              style={{
                                                padding: "20px 24px",
                                                background: "#FFFFFF",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "1fr 1fr",
                                                  columnGap: 60,
                                                  rowGap: 24,
                                                }}
                                              >
                                                <Field label="Order ID" value={selectedRow?.id} />

                                                <Field
                                                  label="Order Status"
                                                  value={
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        height: "20px",
                                                        width: "fit-content",
                                                        padding: "5px 10px",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        fontFamily: "Montserrat",
                                                        fontSize: 12,
                                                        fontStyle: "normal",
                                                        fontWeight: 600,
                                                        borderRadius: "99px",
                                                        ...((() => {
                                                          switch (selectedRow?.status?.toLowerCase()) {
                                                            case "to process": return { color: "#6C757D", border: "1px solid #6C757D", background: "#F8F9FA" };
                                                            case "processed": return { color: "#2C7BE5", border: "1px solid #2C7BE5", background: "#CFE2FF" };
                                                            case "shipping": return { color: "#CC9A06", border: "1px solid #CC9A06", background: "#FFF3CD" };
                                                            case "completed": return { color: "#146C43", border: "1px solid #146C43", background: "#D1E7DD" };
                                                            case "cancelled":
                                                            case "canceled": return { color: "#B02A37", border: "1px solid #B02A37", background: "#F8D7DA" };
                                                            default: return { color: "#6C757D", border: "1px solid #6C757D", background: "#F8F9FA" };
                                                          }
                                                        })())
                                                      }}
                                                    >
                                                      {selectedRow?.status?.toLowerCase() === 'canceled' ? 'Cancelled' : selectedRow?.status}
                                                    </span>
                                                  }
                                                />

                                                <Field
                                                  label="Items"
                                                  value={`${selectedRow?.itemsCount} items`}
                                                />

                                                <Field
                                                  label="Order Time"
                                                  value={selectedRow?.orderTime}
                                                />

                                                <Field
                                                  label="Update Time"
                                                  value={selectedRow?.updateTime}
                                                />

                                                <Field
                                                  label="Linked StockInstance"
                                                  value={selectedRow?.linkedStock}
                                                />

                                                <Field
                                                  label="Order Price"
                                                  value={selectedRow?.totalPrice}
                                                />

                                                {/* Falls back to SGD 0.00, not "NA": an order whose
                                                    items carry no Platform Pricing base price is a
                                                    real zero by the agreed rule, not a missing value. */}
                                                <Field
                                                  label="Base Price Subtotal"
                                                  value={selectedRow?.basePriceSubtotal || "SGD 0.00"}
                                                />

                                                <Field
                                                  label="Settlement Price"
                                                  value={selectedRow?.settlementPrice || "NA"}
                                                />

                                                <Field
                                                  label="Last Modified By"
                                                  value={selectedRow?.updatedBy || "NA"}
                                                />

                                                <Field
                                                  label="Last Modified Time"
                                                  value={selectedRow?.modified_at || "NA"}
                                                />

                                                <Field
                                                label="Open ID"
                                                value={
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 6,
                                                      minWidth: 0,
                                                    }}
                                                  >
                                                    {/* Open ID Text */}
                                                    {selectedRow?.uuid ?(<span
                                                      style={{
                                                        flex: 1,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        color: "#0D6EFD",
                                                        fontSize: "12px",
                                                        fontWeight:500,
                                                        textDecorationLine: "underline",
                                                      }}
                                                      title={selectedRow?.uuid || "NA"}
                                                      onClick={() => copyToClipboard(selectedRow?.uuid)}
                                                    >
                                                      {selectedRow?.uuid}
                                                    </span>):"NA"}

                                                    {/* Copy Icon + Tooltip Wrapper */}
                                                    {selectedRow?.uuid ?(<div
                                                      style={{
                                                        position: "relative",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        flexShrink: 0,
                                                      }}
                                                    >
                                                      <Copy
                                                        size={14}
                                                        style={{ cursor: "pointer", stroke:"#0D6EFD" }}
                                                        onClick={() => copyToClipboard(selectedRow?.uuid)}
                                                      />

                                                      {/* Copied label - absolute so it doesn't shift layout */}
                                                      {copied && (
                                                        <span
                                                          style={{
                                                            position: "absolute",
                                                            left: "calc(100% + 6px)",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            fontSize: "12px",
                                                            color: "#0D6EFD",
                                                            fontWeight: 500,
                                                            whiteSpace: "nowrap",
                                                            pointerEvents: "none",
                                                          }}
                                                        >
                                                          Copied!
                                                        </span>
                                                      )}
                                                    </div>):""}
                                                  </div>
                                                }
                                              />
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                        {drawerTab === "order-items" && (
                                          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

                                            {/* ================= ORDER ITEMS ================= */}
                                            <div
                                              style={{
                                                borderRadius: '12px',
                                                overflow: "hidden",
                                                border: "1px solid #E9ECEF",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  background: "#F8F9FA",
                                                  padding: "15px 20px",
                                                  fontWeight: 600,
                                                  fontSize: 14,
                                                  color:'#212529',
                                                  width: '591px'
                                                }}
                                              >
                                                Order Items
                                              </div>

                                              <div style={{ padding: 16 }}>
                                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                  <thead>
                                                    <tr style={{ background: "#E9ECEF" }}>
                                                      <th style={{color: '#212529', textAlign: "left", padding: "10px", fontSize: 12, fontWeight: 700, width:300 }}>Product</th>
                                                      <th style={{color: '#212529', textAlign: "left", padding: "10px", fontSize: 12, fontWeight: 700 }}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                          Unit Price
                                                          <div
                                                            style={{ position: "relative", display: "inline-flex", alignItems: "center", cursor: "default" }}
                                                            onMouseEnter={(e) => showTooltipHandler("The Unit Price of every item paid by customers in the Order. Transmitted from e-Commerce platform.", e)}
                                                            onMouseLeave={hideTooltipHandler}
                                                          >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                              <g clipPath="url(#clip0_drawer_unitprice)">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.1456 7.39094C4.97372 7.39094 4.91122 7.27031 4.9556 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                              </g>
                                                              <defs>
                                                                <clipPath id="clip0_drawer_unitprice">
                                                                  <rect width="10" height="10" fill="white" />
                                                                </clipPath>
                                                              </defs>
                                                            </svg>
                                                          </div>
                                                        </div>
                                                      </th>
                                                      <th style={{color: '#212529', textAlign: "left", padding: "10px", fontSize: 12, fontWeight: 700 }}>Qty</th>
                                                    </tr>
                                                  </thead>

                                                  <tbody>
                                                    {paginatedOrderItems.map((product, index) => (
                                                      <tr key={index} style={{
                                                        backgroundColor: index % 2 === 1 ? "#F8F9FA" : "#FFFFFF",
                                                      }}>
                                                        <td style={{ padding: "10px", borderTop: "1px solid #E9ECEF", fontSize: 12 }}>
                                                          <div style={{ fontWeight: 400, color:'#212529' }}>{product.name}</div>
                                                          <div style={{ fontWeight: 400, fontSize: 10, color: "#6C757D", marginTop: 4 }}>
                                                            Variation: {product.variation}
                                                          </div>
                                                        </td>

                                                        <td style={{ fontWeight: 400, padding: "10px", borderTop: "1px solid #E9ECEF", fontSize: 12 }}>
                                                          {product.unitPrice}
                                                        </td>

                                                        <td style={{ fontWeight: 400, padding: "10px", borderTop: "1px solid #E9ECEF", fontSize: 12 , textAlign: "right"}}>
                                                          {product.qty}
                                                        </td>
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </table>
                                                <div className="pagination" style={{borderTop:'1px solid rgb(233, 236, 239)', padding:0}}>
                                                  <div className="pagination-info">
                                                    {`${(orderItemsPage - 1) * DRAWER_PAGE_SIZE + 1} - ${Math.min(
                                                      orderItemsPage * DRAWER_PAGE_SIZE,
                                                      orderItemsTotal
                                                    )} of ${orderItemsTotal}`}
                                                  </div>

                                                  <Pagination
                                                    currentPage={orderItemsPage}
                                                    totalPages={orderItemsTotalPages}
                                                    onPageChange={setOrderItemsPage}
                                                  />
                                                </div>
                                              </div>
                                            </div>


                                            {/* ================= LINKED STOCK INSTANCE ================= */}
                                            <div
                                              style={{
                                                borderRadius: 12,
                                                overflow: "hidden",
                                                border: "1px solid #E9ECEF",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  background: "#F8F9FA",
                                                  padding: "15px 20px",
                                                  fontWeight: 600,
                                                  fontSize: 14,
                                                  color:'#212529',
                                                  width: '591px'
                                                }}
                                              >
                                                Linked StockInstance
                                              </div>
                                              
                                              {stockItemsTotal === 0 ? (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "40px 20px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {/* Yellow Circle Icon */}
                                                    <div
                                                    style={{
                                                      position: "relative",
                                                      width: 95,
                                                      height: 95,
                                                      marginBottom: 20,
                                                    }}
                                                  >
                                                    {/* Yellow Circle */}
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                      }}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="95"
                                                        height="95"
                                                        viewBox="0 0 98 97"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M96.4098 48.1157C96.4098 57.4342 93.6119 66.5434 88.3701 74.2914C83.1282 82.0395 75.6777 88.0783 66.9608 91.6443C58.2438 95.2104 48.652 96.1434 39.3981 94.3254C30.1443 92.5075 21.6441 88.0202 14.9725 81.4311C8.30081 74.8419 3.75736 66.4468 1.91666 57.3074C0.0759566 48.168 1.02066 38.6947 4.63133 30.0855C8.242 21.4764 14.3565 14.118 22.2015 8.94095C30.0465 3.76388 39.2698 1.00064 48.7049 1.00064C54.9788 0.968282 61.1968 2.16486 66.9995 4.52115C72.8021 6.87745 78.074 10.3467 82.5104 14.7282C86.9467 19.1097 90.4594 24.3165 92.8452 30.0473C95.231 35.7782 96.4426 41.9194 96.4098 48.1157Z"
                                                          fill="#FFEB00"
                                                          stroke="black"
                                                          strokeWidth="2"
                                                        />
                                                      </svg>
                                                    </div>

                                                    {/* Link Icon (centered) */}
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                      }}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="50"
                                                        height="45"
                                                        viewBox="0 0 51 46"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M20.8809 24.5001C21.7777 25.5821 22.9218 26.4774 24.2356 27.1252C25.5494 27.7731 27.0023 28.1583 28.4955 28.2549C29.9888 28.3514 31.4877 28.1569 32.8904 27.6847C34.2931 27.2124 35.5668 26.4734 36.6253 25.5178L42.8896 19.8639C44.7914 18.0867 45.8438 15.7064 45.82 13.2357C45.7962 10.765 44.6982 8.4016 42.7624 6.65449C40.8267 4.90737 38.208 3.91636 35.4706 3.89489C32.7331 3.87342 30.0958 4.82321 28.1267 6.5397L24.5351 9.76239M29.2334 20.7309C28.3366 19.6488 27.1926 18.7535 25.8787 18.1057C24.5649 17.4578 23.1121 17.0726 21.6188 16.9761C20.1255 16.8795 18.6267 17.074 17.224 17.5463C15.8212 18.0185 14.5475 18.7575 13.489 19.7132L7.22473 25.367C5.3229 27.1442 4.27055 29.5245 4.29434 31.9952C4.31813 34.4659 5.41615 36.8293 7.35191 38.5765C9.28767 40.3236 11.9063 41.3146 14.6438 41.3361C17.3812 41.3575 20.0185 40.4077 21.9876 38.6912L25.5583 35.4685"
                                                          stroke="black"
                                                          strokeWidth="5"
                                                          strokeLinecap="round"
                                                        />
                                                      </svg>
                                                    </div>

                                                    {/* Black X badge (top-left overlap) */}
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        top: -8,
                                                        left: -8,
                                                      }}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="35"
                                                        height="35"
                                                        viewBox="0 0 36 36"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M17.4561 0C27.2581 -0.00878806 35.1334 7.94337 35.0801 17.79C35.0268 27.361 27.1067 35.2064 17.5088 35.1797C7.81332 35.1528 -0.026636 27.2359 0 17.5049C0.0268825 7.88963 7.88488 0.00889483 17.4561 0Z"
                                                          fill="black"
                                                        />
                                                        <path
                                                          d="M23.1514 9.78418L17.793 15.1562L12.4365 9.78418C11.6969 9.0427 10.4974 9.04266 9.75781 9.78418C9.01818 10.5259 9.01826 11.7289 9.75781 12.4707L15.1152 17.8428L9.75781 23.2158C9.01845 23.9575 9.01843 25.1597 9.75781 25.9014C10.4975 26.6431 11.6969 26.6431 12.4365 25.9014L17.793 20.5283L23.1514 25.9014C23.891 26.643 25.0895 26.6431 25.8291 25.9014C26.5688 25.1596 26.5688 23.9576 25.8291 23.2158L20.4717 17.8428L25.8291 12.4707C26.5688 11.7289 26.5688 10.5259 25.8291 9.78418C25.0895 9.04299 23.8909 9.04301 23.1514 9.78418Z"
                                                          fill="white"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>


                                                  {/* Title */}
                                                  <div
                                                    style={{
                                                      fontWeight: 600,
                                                      fontSize: 16,
                                                      color: "#212529",
                                                      marginBottom: 6,
                                                    }}
                                                  >
                                                    No Linked StockInstances
                                                  </div>

                                                  {/* Subtitle */}
                                                  <div
                                                    style={{
                                                      fontSize: 13,
                                                      color: "#6C757D",
                                                    }}
                                                  >
                                                    No StockInstances Linked to this Order
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                <div style={{ padding: 16 }}>
                                                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                    <thead>
                                                      <tr style={{ background: "#E9ECEF" }}>
                                                        <th style={{color: '#212529', textAlign: "left", padding: "10px", fontSize: 12, fontWeight: 700 }}>Stock</th>
                                                        <th style={{color: '#212529', textAlign: "left", padding: "10px", fontSize: 12, fontWeight: 700 }}>StockInstance</th>
                                                        <th style={{color: '#212529', textAlign: "left", padding: "10px", fontSize: 12, fontWeight: 700 }}>Qty</th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      {paginatedStockItems.map((stock, index) => (
                                                        <tr
                                                          key={index}
                                                          style={{
                                                            backgroundColor: index % 2 === 1 ? "#F8F9FA" : "#FFFFFF",
                                                          }}
                                                        >
                                                          {/* STOCK COLUMN */}
                                                          <td style={{ padding: "10px",width:"auto" }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                <img
                                                                  src={stock.image || noImage}
                                                                  alt={stock.stockName}
                                                                  style={{
                                                                    // width: "40px",
                                                                    height: "40px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "4px",
                                                                    border: "1px solid #E9ECEF",
                                                                  }}
                                                                />
                                                                <div>
                                                          
                                                                <div style={{ fontSize: "12px", fontWeight: "500",color:"#212529",fontWeight:400 }}>
                                                                  {stock.stockName}
                                                                </div>
                                                                <div style={{ fontSize: "10px", color: "#6C757D" }}>
                                                                  {stock.stockSku}{stock.stockModelNumber ? ` | ${stock.stockModelNumber}` : ''}
                                                                </div>
                                                                <div style={{ display: "flex", gap: "4px", marginTop: "4px" }}>
                                                                  <span
                                                                    style={{
                                                                      padding: "2px 5px",
                                                                      borderRadius: "12px",
                                                                      fontSize: "8px",
                                                                      fontWeight: "600",
                                                                      backgroundColor: "#FFEB00",
                                                                      color: "#212529",
                                                                    }}
                                                                  >
                                                                    {stock.condition}
                                                                  </span>

                                                                  <span
                                                                    style={{
                                                                      padding: "2px 5px",
                                                                      borderRadius: "12px",
                                                                      fontSize: "8px",
                                                                      fontWeight: "600",
                                                                      backgroundColor: "#FFEB00",
                                                                      color: "#212529",
                                                                    }}
                                                                  >
                                                                    {stock.condition_type}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </td>

                                                          {/* STOCK INSTANCE COLUMN */}
                                                          <td style={{ padding: "10px" }}>
                                                            <div style={{ fontSize: "12px", fontWeight: "400",color: "#212529" }}>
                                                              {stock.skuId}
                                                            </div>
                                                            <div style={{ fontSize: "10px", color: "#6C757D" }}>
                                                              {stock.branch} | SGD {stock.price}
                                                            </div>
                                                          </td>

                                                          {/* QTY COLUMN */}
                                                          <td style={{ padding: "10px", fontSize: "12px",textAlign: "right", fontWeight: "400",color: "#212529" }}>
                                                            {stock.instanceQty}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>

                                                  </table>
                                                </div>
                                                  {/* Pagination */}
                                                  <div
                                                    className="pagination"
                                                    style={{ borderTop: "1px solid #E9ECEF", padding: 0, paddingRight: 15, paddingBottom:10 }}
                                                  >
                                                    <div className="pagination-info">
                                                      {`${(stockItemsPage - 1) * DRAWER_PAGE_SIZE + 1} - ${Math.min(
                                                        stockItemsPage * DRAWER_PAGE_SIZE,
                                                        stockItemsTotal
                                                      )} of ${stockItemsTotal}`}
                                                    </div>

                                                    <Pagination
                                                      currentPage={stockItemsPage}
                                                      totalPages={stockItemsTotalPages}
                                                      onPageChange={setStockItemsPage}
                                                    />
                                                  </div>
                                                </>
                                              )}

                                            </div>

                                          </div>
                                        )}



                                        {drawerTab === 'additional-info' && (
                                            <div
                                                className="card-section"
                                                style={{
                                                    borderRadius: '12px',
                                                    overflow: 'hidden',
                                                    border: '1px solid #E9ECEF',
                                                }}
                                            >
                                                <div
                                                    className="card-header"
                                                    style={{
                                                        backgroundColor: '#F8F9FA',
                                                        padding: '15px 20px',
                                                        fontFamily: 'Montserrat',
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: '#212529',
                                                        borderBottom: 'none',
                                                    }}
                                                >
                                                    Notes
                                                </div>
                                                <div
                                                    className="card-body"
                                                    style={{
                                                        backgroundColor: '#FFFFFF',
                                                        padding: '15px 20px',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        whiteSpace: 'normal',
                                                    }}
                                                >
                                                    <div
                                                        className="field-value notes-preserve"
                                                        style={{
                                                            fontSize: 12,
                                                            color: selectedRow?.notes ? '#212529' : '#ADB5BD',
                                                            minHeight: 24,

                                                        }}
                                                    >
                                                        {selectedRow?.notes || 'NA'}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                                <style>
                                  {`
                                    .drawer-title{
                                      border-bottom: none;
                                    }

                                    .entity-drawer .drawer-tabs, .filter-drawer .drawer-tabs{
                                      border-bottom: none;
                                    } 
                                  `}
                                </style>
                            </div>

                        {/* Unit Price Tooltip */}
                        {showTooltip && (
                          <div
                            style={{
                              position: "fixed",
                              top: tooltipPosition.top,
                              left: tooltipPosition.left,
                              transform: "translate(-50%, calc(-100% - 8px))",
                              background: "#495057",
                              color: "white",
                              padding: "16px",
                              borderRadius: "8px",
                              fontSize: "12px",
                              zIndex: 9999,
                              width: "300px",
                              maxWidth: "300px",
                              pointerEvents: "none",
                            }}
                          >
                            {tooltipContent}
                            <div style={{ width: 0, height: 0, borderRight: "15px solid transparent", borderBottom: "15px solid transparent", borderTop: "15px solid #495057", position: "absolute", borderLeft: "15px solid transparent", left: "50%",top:'98%', transform: "translateX(-50%)" }} />
                          </div>
                        )}
                        </>
                    );
}
